import React from 'react';
import {NavLink, useLocation } from "react-router-dom";
import {IconBox, Type as T} from "@infobis/ui-styles-utils";
import colors from '@infobis/ui-styles-utils/colors'

import {Align, Rotate} from "@baseTypes/baseType";

import List from "@elements/list/List";
import ItemList from "@elements/itemList/ItemList";

import st from "./monitoringMenu.module.scss"

import {HoverProvider} from "@infobis/ui-styles-utils";

type MenuType = "fields" | "units" | "three"

interface NavItem {
  icon: T.IconName
  name: string
  type: MenuType
}

const MonitoringMenu = () => {

  const location = useLocation()
  const isActive = (path: string) => {
    return location.pathname === path;
  }
  let list: NavItem[] = [
    {
      icon: T.IconName.Field,
      name: "Геозоны",
      type: "fields",
    }, {
      icon: T.IconName.Vehicle,
      name: "Техника",
      type: "units",
    }
  ]
  
  return (
      <List
        rotate={Rotate.Row}
        className={st.menu}
        align={Align.Start}
      >
        {
          list.map((item: NavItem) => {
            const path = `/map/${item.type}`
            return (
              <ItemList key={item.name}>
                <HoverProvider>
                <NavLink
                    to={path}
                    replace={true}
                    className={`${st.item}`}
                >
                    <IconBox
                      className={`${st['item__icon']} ${isActive(path) && st['item__icon--active']}`}
                      icon={item.icon}
                      color={isActive(path) ? colors.CONTROL_PRIMARY_CONTENT : colors.TYPO_SECONDARY}
                      hoverColor={colors.CONTROL_PRIMARY_CONTENT}
                    />
                    <div className={st.item__name}>{item.name}</div>
                </NavLink>
                </HoverProvider>
              </ItemList>
            )
          })
        }
      </List>
  )
}
export default MonitoringMenu;